import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import tradeDataStore from "@/store/tradeDataStore";
import { getActiveIcebergLegForOP } from "./notionalLeg1Helpers";

// OP-only tooltip — shows the iceberg notional that the CP can see for leg 1.
// Suppressed when not OP, when releaseNotionalLeg1 is missing, or when it
// equals notionalLeg1 (iceberg back to 100%).
export function notionalLeg1TooltipValueGetter(params: any): string | null {
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);

  const thisTrade = tradeDataStore
    .getState()
    .tradeData.find((trade) => trade.esid === fullTradeData?.esid);

  const leg = getActiveIcebergLegForOP(params, thisTrade);
  if (!leg) return null;

  const formatted = returnSizeFormatted(
    leg.releaseNotionalLeg1!,
    leg.instrumentType,
  );
  return `Iceberg size shown to counterparty: ${formatted}`;
}
